import { put, takeLatest } from "redux-saga/effects";

import { requestSalutationList } from "../../../services/salutation";
import {
  fetchsSalutationListRequest,
  fetchsSalutationListSuccess,
  fetchsSalutationListFailure,
} from "../../reducers/salutation";

export function* watchSalutationSaga() {
  yield takeLatest(fetchsSalutationListRequest, fetchSalutationList);
}

/**
 *
 * @param {*} param0
 */
function* fetchSalutationList({ payload }) {
  try {
    const response = yield requestSalutationList(payload);
    yield put(fetchsSalutationListSuccess(response));
  } catch (error) {
    yield put(fetchsSalutationListFailure("Failed to get list of Salutation"));
  }
}
